import {
  CalculateEVRequest,
  CalculateEVResponse,
  CalculateEVApiResult,
} from './evTypes';
import { getPropsLocalApiBase } from './leagueConfig';

/**
 * Get the base URL for EV calculation API.
 * Uses the stokastic-site proxy endpoint via REACT_APP_DFS_MARKETING_API.
 */
const getEvApiBaseUrl = (): string => {
  return process.env.REACT_APP_DFS_MARKETING_API || 'https://www.stokastic.com';
};

/**
 * Calculate EV for outcomes with custom projections.
 * Calls the stokastic-site pass-through endpoint which forwards to OddsShopper.MainApi.
 */
export async function calculateEV(
  request: CalculateEVRequest,
  accessToken?: string | null
): Promise<CalculateEVApiResult> {
  try {
    // Local dev: hit the local MainApi directly (through the dev-server proxy when the base is relative)
    const localApiBase = getPropsLocalApiBase();
    const url = localApiBase
      ? new URL(`${localApiBase}/api/projections/props/calculate-ev`, window.location.origin).toString()
      : `${getEvApiBaseUrl()}/api/ev/calculate`;

    const headers: HeadersInit = {
      'Content-Type': 'application/json',
    };

    if (!localApiBase && accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    }

    const response = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      return {
        success: false,
        data: null,
        error: `API returned ${response.status}`,
      };
    }

    const data: CalculateEVResponse = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error instanceof Error ? error.message : 'Unknown error',
    };
  }
}
